export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';
export const SELECT_CURRENT_INVOICE = 'SELECT_CURRENT_INVOICE';
export const REFRESH_INVOICES = 'REFRESH_INVOICES';
